// Shared date-range defaults so every dashboard uses the same conventions.
// Dates are ISO YYYY-MM-DD (matches backend `attempt_date_ist` storage format
// and the DatePicker component's value shape).

/** First day of the current month, in the user's local calendar (which is IST for this app). */
export function firstOfMonth(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}-01`;
}

/** Today (local), as YYYY-MM-DD. */
export function today(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Yesterday (local), as YYYY-MM-DD. */
export function yesterday(now = new Date()) {
  const d = new Date(now);
  d.setDate(d.getDate() - 1);
  return today(d);
}

/** Analytics dashboards default: current month → today.
 *  Used by the main Dashboard and Agent Profile page. */
export const DEFAULT_ANALYTICS_RANGE = () => ({
  from: firstOfMonth(),
  to: today(),
});

/** Ops Dashboard + Lite Report default: yesterday only (single day).
 *  We exclude "today" so numbers are stable and don't shift as data comes in
 *  during the day. Users can widen the range via the date picker. */
export const DEFAULT_OPS_RANGE = () => ({
  from: yesterday(),
  to: yesterday(),
});

/** Uploads list default: just today (uploads are typically same-day). */
export const DEFAULT_UPLOADS_RANGE = () => ({
  from: today(),
  to: today(),
});
